export async function extractDocumentText(file: File): Promise<string> {
    const name = file.name.toLowerCase();
    const type = file.type;

    if (
        type.startsWith('text/') ||
        name.endsWith('.txt') ||
        name.endsWith('.md') ||
        name.endsWith('.csv') ||
        name.endsWith('.json')
    ) {
        return new Promise((resolve, reject) => {
            const r = new FileReader();
            r.onload = () => resolve(String(r.result ?? ''));
            r.onerror = () => reject(new Error('read_failed'));
            r.readAsText(file);
        });
    }

    if (type === 'application/pdf' || name.endsWith('.pdf')) {
        const pdfjs = await import('pdfjs-dist');
        const version = (pdfjs as { version?: string }).version ?? '3.11.174';
        if (!pdfjs.GlobalWorkerOptions.workerSrc) {
            pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${version}/build/pdf.worker.min.js`;
        }
        const buf = await file.arrayBuffer();
        const pdf = await pdfjs.getDocument({ data: buf }).promise;
        let out = '';
        for (let i = 1; i <= pdf.numPages; i++) {
            const page = await pdf.getPage(i);
            const tc = await page.getTextContent();
            const line = tc.items
                .map((it) => ('str' in it ? (it as { str: string }).str : ''))
                .join(' ');
            out += line + '\n';
        }
        return out.trim();
    }

    throw new Error('unsupported_type');
}
